module.exports = __webpack_public_path__ + "img/luke.3bb6e4a.webp";